import React from 'react'
import { i18nTranslate, IS_BROWSER } from 'src/utils'
import { CancelAllModal } from './CancelAllModal'
import { Link } from 'react-router-dom'
import './styles.scss'
import LinkFromContentStack from 'src/deps/LinkFromContantStack'
function SubscriptionFooter(props) {
  const [cancelAllModalShow, setCancelAllModalShow] = React.useState(false)
  const navigateToTermsUrl = async () => {
    if (IS_BROWSER) {
      //const links = new FormInputLabels()
      // window.open(links.retailCustomerLinks?.subscriptionAgreement)
      if (LinkFromContentStack?.termAndConditionLink) {
        window.open(LinkFromContentStack?.termAndConditionLink)
      } else {
        const termAndConditionLink =
          await LinkFromContentStack.fetchTermsConditionsLink()
        window.open(termAndConditionLink)
      }
    }
  }
  return (
    <>
      <div>
        {!props.isFromNextOrder && (
          <div className="subfooter-line-divider"></div>
        )}
        <div className="subfooter-button-container">
          <div className="subfooter-terms">
            <Link
              onClick={() => navigateToTermsUrl()}
              role="button"
              tabIndex={0}>
              {i18nTranslate(
                'editSubscription.TermsConditions',
                'Subscription Terms and Conditions'
              )}
            </Link>
          </div>
          {!props.isFromNextOrder && (
            <button
              className="subfooter-cancel-allsub"
              data-testid="qa-cancel-all-subscription-items"
              onClick={() => setCancelAllModalShow(true)}>
              {i18nTranslate(
                'subscription.cancelAllSubscriptionItems',
                'Cancel all subscription items'
              )}
            </button>
          )}
        </div>
      </div>
      <CancelAllModal
        show={cancelAllModalShow}
        onHide={() => setCancelAllModalShow(false)}
        handleCancelItem={props.handleCancelItem}
      />
    </>
  )
}

export { SubscriptionFooter }
